import Vue from 'vue'
import {
  Editor,
  Toolbar
} from '@wangeditor/editor-for-vue'
// 官方样式（含工具栏、编辑区、全屏等全部样式）
import '@wangeditor/editor/dist/css/style.css'

import {
  Boot
} from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'
import WangEditorHtml from './wangEditorHtml'

// 全局注册编辑器与工具栏组件（供 <WangEditor> / <WangToolbar> 使用）
Vue.component('WangEditor', Editor)
Vue.component('WangToolbar', Toolbar)

// 注册附件上传模块
Boot.registerModule(attachmentModule)

// 注册自定义「源码」菜单（key 需唯一，与 toolbarKeys 中的 "html" 对应）
Boot.registerMenu({
  key: 'html',
  factory () {
    return new WangEditorHtml()
  }
})
